import axios from 'axios';
import { getMicroServiceUrl } from '../helpers/helpers';

export const getLeaderboard = (propertyId) => ({
  type: 'GET_LEADERBOARD',
  payload: axios.get(
    `${getMicroServiceUrl('business-user')}get_meter_reading_leaderboard/${propertyId}`,
  ),
});
